module.exports = __webpack_public_path__ + "static/img/5-pd.e4b6b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/5-pd.png
// module id = 7A5W
// module chunks = 0